<template lang="pug">

  .course-points-shop-popup(@click.self="closePopup")
    .course-points-shop-confirm
      Icon.course-points-shop-product__close(
        icon="side-close"
        @click="closePopup"
      )

      template(v-if="!promocode")
        p.course-points-shop-confirm__description
          span(v-if="product.price")
            | Хотите потратить
            span.course-points-shop-confirm__highlight {{product.price}}
            | {{getNoun(product.price, 'бонус', 'бонуса', 'бонусов')}},
            |   чтобы получить продукт
          span
            |  {{product.name}}{{product.price ? '?' : ''}}
        GiftIcon.course-points-shop-confirm__image
        .course-points-shop-confirm__button-list
          UiButton.course-points-shop-confirm__button(
            color="gray"
            @click="closePopup"
          ) Отменить
          UiButton.course-points-shop-confirm__button(
            :isLoading="purchasing"
            @click="purchase"
          ) {{product.price ? 'Приобрести' : 'Получить' }}

      template(v-else-if="promocode")
        p.course-points-shop-confirm__description
          a(href="https://likecentre.ru/toolbox-lms-shop" target="_blank" alt="") Перейди на страницу
          | , заполни данные по себе и введи промокод:
        p.-promocode-(
          @click="copyPromocode"
        )
          | {{promocode}}

</template>

<script>
import { mapState } from 'vuex';
import GiftIcon from './icon/Gift';

export default {
  components: {
    GiftIcon
  },
  props: ['product'],
  data: () => ({
    promocode: ''
  }),
  computed: {
    ...mapState('coursePointsShop', {
      purchasing: s => s.meta.purchasing
    })
  },
  methods: {
    getNoun(number, one, two, five) {
      let n = Math.abs(number);
      n %= 100;
      if (n >= 5 && n <= 20) {
        return five;
      }
      n %= 10;
      if (n === 1) {
        return one;
      }
      if (n >= 2 && n <= 4) {
        return two;
      }
      return five;
    },
    closePopup() {
      if (!this.purchasing) {
        this.$store.dispatch('coursePointsShop/setData', {
          path: 'popupOffer',
          value: {}
        });
      }
    },
    async purchase() {
      const res = await this.$store.dispatch('coursePointsShop/purchase', {
        product: this.product,
        courseId: this.$route.params.courseId
      });
      if (res && res.promocode) {
        this.promocode = res.promocode;
      }
    },
    copyPromocode() {
      const dummy = document.createElement('textarea');
      document.body.appendChild(dummy);
      dummy.value = this.promocode;
      dummy.select();
      document.execCommand('copy');
      document.body.removeChild(dummy);
      this.$store.dispatch(
        'ajax/addMessage',
        { message: 'Промокод скопирован', type: 'success' },
        { root: true }
      );
    }
  }
};
</script>
